<div class="container">
    <div *ngIf="isLoading" class="spinner-content">
        <div [ngClass]="{'spinner--fixed': isFixedPosition, 'spinner--fixed-with-search-panel': isWithSearchPanel}" class="spinner"></div>
    </div>
    <ng-content></ng-content>
</div>